module.exports = __webpack_public_path__ + "788db4fa989815945240303ee628bfad.png";